
import React from "react";
import { Button } from "@/components/ui/button";
import { useSubmitForm } from "@/hooks/useSubmitForm";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";
import BusinessInfoSection from "@/components/forms/sections/BusinessInfoSection";
import TagsAndMediaSection from "@/components/forms/sections/TagsAndMediaSection";
import ContactInfoSection from "@/components/forms/sections/ContactInfoSection";
import SocialMediaSection from "@/components/forms/sections/SocialMediaSection";

const SubmitForm: React.FC = () => {
  const {
    formData,
    formErrors,
    isSubmitting,
    handleChange,
    handleCategoryChange,
    handleMediaChange,
    handleSubmit
  } = useSubmitForm();

  const [submissionError, setSubmissionError] = React.useState<string | null>(null);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmissionError(null);

    try {
      await handleSubmit(e);
    } catch (error: any) {
      setSubmissionError(error.message);
    }
  };

  return (
    <form onSubmit={onSubmit} className="space-y-6">
      {submissionError && (
        <Alert variant="destructive" className="mb-6 alert-destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Error</AlertTitle>
          <AlertDescription>
            {submissionError}
          </AlertDescription>
        </Alert>
      )}

      <BusinessInfoSection
        name={formData.name}
        description={formData.description}
        address={formData.address}
        city={formData.city}
        county={formData.county}
        postcode={formData.postcode}
        what3words={formData.what3words}
        region={formData.region}
        category={formData.category}
        handleChange={handleChange}
        handleCategoryChange={handleCategoryChange}
        formErrors={formErrors}
      />

      <TagsAndMediaSection
        tags={formData.tags}
        mediaFiles={formData.mediaFiles}
        handleChange={handleChange}
        handleMediaChange={handleMediaChange}
        formErrors={formErrors}
      />

      <ContactInfoSection
        website={formData.website}
        phone={formData.phone}
        email={formData.email}
        handleChange={handleChange}
        formErrors={formErrors}
      />

      <SocialMediaSection
        facebook={formData.facebook}
        instagram={formData.instagram}
        tiktok={formData.tiktok}
        handleChange={handleChange}
        formErrors={formErrors}
      />

      <Button
        type="submit"
        className="w-full bg-eco-500 hover:bg-eco-600"
        disabled={isSubmitting}
      >
        {isSubmitting ? "Submitting..." : "Submit Listing"}
      </Button>
    </form>
  );
};

export default SubmitForm;
